import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComboPesquisavelModule } from './../common/combo-pesquisavel/combo-pesquisavel.module';
import { AlunoComponent } from './aluno.component';
import { BotoesRelatorioComponent, CadastarAlunoComponent } from './cadastar-aluno/cadastar-aluno.component';

import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { SharedDirectivesModule } from '../../directives/shared-directives.module';
import { CadastroEnderecoModule } from '../common/cadastro-endereco/cadastro-endereco.module';
import { ComboBeneficiarioModule } from '../common/combo-beneficiario/combo-beneficiario.module';
import { ComboContratoModule } from "../common/combo-contrato/combo-contrato.module";
import { ComboEstadoCivilModule } from '../common/combo-estado-civil/combo-estado-civil.module';
import { ComboTipoSangueModule } from '../common/combo-tipo-sangue/combo-tipo-sangue.module';
import { ComboUfModule } from '../common/combo-uf/combo-uf.module';
import { ComboSexoModule } from '../common/combo-sexo/combo-sexo.module';
import { ComboRacaModule } from '../common/combo-raca/combo-raca.module';
import { ComboGrauParentescoModule } from '../common/combo-grau-parentesco/combo-grau-parentesco.module';
import { ComboGrauInstrucaoModule } from '../common/combo-grau-instrucao/combo-grau-instrucao.module';
import { PessoaFisicaModule } from '../common/pessoa-fisica/pessoa-fisica.module';
import { FamiliarAlunoModule } from '../familiar-aluno/familiar-aluno.module';
import { AlunoContratoComponent } from "./aluno-contrato/aluno-contrato.component";
import { AlunoRoutingModule } from './aluno-routing.module';
import { AtendimentoApoioAlunoComponent } from './atendimento-apoio-aluno/atendimento-apoio-aluno.component';
import { BeneficioSocialPessoaFisicaAlunoComponent } from './beneficio-social-pessoa-fisica-aluno/beneficio-social-pessoa-fisica-aluno.component';
import {
    CadastrarResponsavelFamiliarAlunoComponent
} from './cadastrar-responsavel-familiar-aluno/cadastrar-responsavel-familiar-aluno.component';
import { DadosPessoaisAlunoComponent } from './dados-pessoais-aluno/dados-pessoais-aluno.component';
import { DadosPessoaisFamiliarAlunoComponent } from './dados-pessoais-familiar-aluno/dados-pessoais-familiar-aluno.component';
import { DocumentosAlunoComponent } from './documentos-aluno/documentos-aluno.component';
import { DocumentosFamiliarAlunoComponent } from './documentos-familiar-aluno/documentos-familiar-aluno.component';
import { ListarHistoricoAlunoComponent } from './listar-historico-aluno/listar-historico-aluno.component';
import { MatriculaAlunoComponent } from './matricula-aluno/matricula-aluno.component';
import { ProfissionalFamiliarAlunoComponent } from './profissional-familiar-aluno/profissional-familiar-aluno.component';
import { UniformeAlunoComponent } from './uniforme-aluno/uniforme-aluno.component';
import {
    CadastrarVulnerabilidadeAlunoComponent
} from './vulnerabilidade-aluno/cadastrar-vulnerabilidade-aluno/cadastrar-vulnerabilidade-aluno.component';
import {
    ListarVulnerabilidadeAlunoComponent
} from './vulnerabilidade-aluno/listar-vulnerabilidade-aluno/listar-vulnerabilidade-aluno.component';
import { VulnerabilidadeAlunoComponent } from './vulnerabilidade-aluno/vulnerabilidade-aluno.component';


@NgModule({
    declarations: [AlunoComponent, CadastarAlunoComponent, VulnerabilidadeAlunoComponent,
        CadastrarVulnerabilidadeAlunoComponent, ListarVulnerabilidadeAlunoComponent, BotoesRelatorioComponent,
        DadosPessoaisFamiliarAlunoComponent, DadosPessoaisAlunoComponent, CadastrarResponsavelFamiliarAlunoComponent, ProfissionalFamiliarAlunoComponent,
        AtendimentoApoioAlunoComponent, BeneficioSocialPessoaFisicaAlunoComponent, DocumentosFamiliarAlunoComponent, DocumentosAlunoComponent, UniformeAlunoComponent, MatriculaAlunoComponent,
        AlunoContratoComponent, ListarHistoricoAlunoComponent],
    imports: [
        CommonModule,
        FormsModule,
        AlunoRoutingModule,
        PessoaFisicaModule,
        MaterialCommonModule,
        MatExpansionModule,
        ComboPesquisavelModule,
        ComboBeneficiarioModule,
        CadastroEnderecoModule,
        FamiliarAlunoModule,
        SharedDirectivesModule,
        ComboContratoModule,
        ComboEstadoCivilModule,
        ComboTipoSangueModule,
        ComboUfModule,
        ComboSexoModule,
        ComboRacaModule,
        ComboGrauParentescoModule,
        ComboGrauInstrucaoModule
    ]
})
export class AlunoModule {
}
